module.exports = __webpack_public_path__ + "static/img/calLicm.9ff2d9a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/calLicm.jpg
// module id = DGjX
// module chunks = 1